var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81256 24H24.1872C26.0503 24 27 23.0183 27 21.074V11.1913C27 9.24702 26.0503 8.27473 24.1872 8.27473H21.6254C20.9177 8.27473 20.7027 8.12371 20.2997 7.6516L19.5831 6.80224C19.135 6.28302 18.6784 6 17.7557 6H14.1815C13.2588 6 12.8022 6.28302 12.3542 6.80224L11.6376 7.6516C11.2345 8.11434 11.0107 8.27473 10.3118 8.27473H7.81256C5.94049 8.27473 5 9.24702 5 11.1913V21.074C5 23.0183 5.94049 24 7.81256 24ZM16.0065 21C18.7693 21 21 18.7851 21 16.0002C21 13.2279 18.7693 11 16.0065 11C13.2433 11 11 13.2279 11 16.0002C11 18.7851 13.2562 21 16.0065 21ZM23.0077 11C22.4651 11 22 11.4669 22 11.9961C22 12.5565 22.4651 13 23.0077 13C23.5428 12.9923 24 12.5487 24 11.9961C24 11.4669 23.5428 11 23.0077 11Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.0039 19C17.6616 19 19 17.671 19 16.0001C19 14.3367 17.6616 13 16.0039 13C14.346 13 13 14.3367 13 16.0001C13 17.671 14.3537 19 16.0039 19Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPhoto);
export default __webpack_public_path__ + "static/media/Camera_Photo.fcb6675df5755b0830ba939af71ba104.svg";
export { ForwardRef as ReactComponent };